module.exports = __webpack_public_path__ + "img/nav_icon_uav_selected.ae73ab7d.png";